import { FunctionComponent } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export const NoteSkeleton: FunctionComponent = () => (
  <div data-cy="skeleton-element-note" className="w-full flex flex-wrap gap-6 p-0 md:p-4 lg:p-0">
    <Skeleton containerClassName="lg:w-2/5 w-3/5" className="h-9" />
    <Skeleton containerClassName="w-full" className="h-7" />
    <Skeleton containerClassName="lg:w-2/3 w-4/5" className="h-7" />
    <Skeleton containerClassName="lg:w-2/3 w-full" className="h-7" />
    <Skeleton containerClassName="lg:w-3/4 w-4/5" className="h-7" />
    <Skeleton containerClassName="lg:w-full w-3/5" className="h-7" />
    <Skeleton containerClassName="lg:w-2/5 w-full" className="h-7" />
    <Skeleton containerClassName="lg:w-2/3 w-3/5" className="h-7" />
    <div className="w-full flex gap-6">
      <Skeleton containerClassName="lg:w-1/3 w-1/2" className="h-36" />
      <Skeleton containerClassName="lg:w-1/3 w-1/2" className="h-36" />
    </div>
    <Skeleton containerClassName="lg:w-3/4 w-full" className="h-7" />
  </div>
);
